import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullPublishedCalendarsOption'));
const PublishedCalendarsOption: LazyOption = createLazyOption(
    {
        key: 'publishedCalendars',
        titleStringKey: 'optionTitle_publishACalendar',
        searchTermsStringKey: 'optionTitle_publishACalendar',
        isHidden: () => {
            return !isFeatureEnabled('cal-publishing-settings') || IsShadowMailboxUser();
        },
        allowedOptionKeys: ['CalendarPublishing'],
    },
    lazyFullModule,
    m => m.default
);
export default PublishedCalendarsOption;
